import { AxiosPromise } from 'axios'

import api from '@config/api'

export function getOtimizadorDefault(): AxiosPromise {
  return api.get('/v1/OtimizadorEstoque/Default', {})
}

export function postOtimizadorDefault(data: any): AxiosPromise {
  return api.post('/v1/OtimizadorEstoque/Default', data, {})
}

export function putOtimizadorDefault(data: any): AxiosPromise {
  return api.put('/v1/OtimizadorEstoque/Default', data, {})
}
export function deleteOtimizadorDefault(data: any): AxiosPromise {
  return api.delete('/v1/OtimizadorEstoque/Default?curva=' + data)
}

export default {
  getOtimizadorDefault,
  postOtimizadorDefault,
  putOtimizadorDefault,
  deleteOtimizadorDefault
}
